// extracted by mini-css-extract-plugin
export default {"cls1":"_k3Ezcf9kP9nxSMlwQua","cls2":"JfcZjbtZZcDW9pmWxl37 _k3Ezcf9kP9nxSMlwQua","isTabletDown":"xl9aRdpFqMw2lp0jQo5O","isPhone":"_g3_VoPtBvn9jcK5D5Z5"};